type ArrowProps = {
  color?: string;
  className?: string;
};

const LeftColorArrow = ({ color, className }: ArrowProps = {}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: color || 'var(--brand-background-color)' }}
  >
    <path
      d="M15.8332 10.0003H4.1665M4.1665 10.0003L9.99984 15.8337M4.1665 10.0003L9.99984 4.16699"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronDownArrow = ({ color, className }: ArrowProps = {}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: color || 'var(--brand-background-color)' }}
  >
    <path
      d="M4.5 6.75L9 11.25L13.5 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ColorArrowLink = ({ color, className }: ArrowProps = {}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: color || 'var(--brand-background-color)' }}
  >
    <path
      d="M5.83325 14.1667L14.1666 5.83333M14.1666 5.83333H5.83325M14.1666 5.83333V14.1667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { LeftColorArrow, ChevronDownArrow, ColorArrowLink };
